export default Object.freeze({
  EXAME: 'exame',
  PRESCRICAO: 'prescricao',
});
